import {Component, ElementRef, Input, OnDestroy, OnInit} from '@angular/core';
import {ModalService} from './modal.service';

@Component({
    selector: 'tfl-gentelella-modal-container',
    template: `
        <div *ngIf="visible" class="modal fade in" role="dialog" style="display: block;">
            <div [ngClass]="(isLarge ? 'modal-dialog modal-lg' : 'modal-dialog modal-sm') + (dialogClass ? ' ' + dialogClass : '')">
                <div class="modal-content" [ngClass]="customContentClass">
                    <ng-content></ng-content>
                </div>
            </div>
        </div>
    `
})
export class GentelellaModalContainerComponent implements OnInit, OnDestroy {

    @Input() id: string;
    @Input() isLarge: boolean = false;
    @Input('custom-content-class') customContentClass = '';
    @Input('dialog-class') dialogClass = '';
    visible: boolean = false;

    private element: ElementRef;

    constructor(private _modalService: ModalService, private _el: ElementRef){
        this.element = _el;
    }

    open() {
        this.visible = true;
    }

    close() {
        this.visible = false;
    }

    ngOnDestroy(): void {
        this._modalService.remove(this.id);
        this.element.nativeElement.parentNode.removeChild(this.element.nativeElement)
    }

    ngOnInit(): void {
        let modal = this;

        // ensure id attribute exists
        if (!this.id) {
            console.error('modal must have an id');
            return;
        }

        // move element to bottom of page (just before </body>) so it can be displayed above everything else
        document.body.appendChild(this.element.nativeElement);

        // add self (this modal instance) to the modal service so it's accessible from controllers
        this._modalService.add(this);
    }
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/angular-router-loader/src!./src/dashboard/app/shared/modal/modal-container.component.ts